import React, { useState } from "react";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { brandName } from "../../../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textLightColor,
} from "../../../Constants/Colors";
import defaultLogo from "../../../Assets/Images/Logo/Ideal_Corporate_Services.png";
import footerBg from "../../../Assets/Images/Footer/footerbg.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";
import locationImg from "../../../Assets/Images/Footer/Contact/Location.png";
import phoneImg from "../../../Assets/Images/Footer/Contact/Call.png";
import emailImg from "../../../Assets/Images/Footer/Contact/EMail.png";
import timeImg from "../../../Assets/Images/Footer/Contact/Working-Hours.png";
import { GrSend } from "react-icons/gr";
import { Link } from "react-router-dom";
import { useGetServicesQuery } from "../../../redux/api/ServicesApi/servicesApi";
import { useSubmitContactMutation } from "../../../redux/api/ContactApi/contactApi";
import { useGetSettingsQuery } from "../../../redux/api/SettingsApi/settingsApi";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitContact, { isLoading: isContactSubmitting }] =
    useSubmitContactMutation();
  const [status, setStatus] = useState("idle");

  const { data: servicesData } = useGetServicesQuery({ limit: 100 });
  const { data: settings } = useGetSettingsQuery();

  const services = (servicesData?.services || [])
    .filter((s) => s.status)
    .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
    .slice(0, 6);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await submitContact({
        name: "Newsletter Subscriber",
        phone: "",
        email: email,
        service: "Newsletter Subscription",
        contactMethod: "Email",
        message: "I would like to subscribe to the newsletter.",
      }).unwrap();

      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3000);
    } catch (err) {
      console.error("Newsletter submission failed: ", err);
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  const footerLogo = settings?.footer_logo || settings?.logo || defaultLogo;
  const topLogo = settings?.logo || defaultLogo;

  return (
    <>
      <Container className="footer-top-container">
        <Row className="align-items-center my-3">
          <Col xs={8} md={9} lg={10}>
            <p className="text-justify footer-top-text">
              {settings?.footer_description ||
                "We are innovators, problem-solvers, and tech enthusiasts dedicated to building digital solutions that drive success. Our passion for clean, modern, and scalable software helps businesses stay ahead in an ever-evolving digital landscape."}
            </p>
          </Col>
          <Col xs={4} md={3} lg={2}>
            <Image src={topLogo} className="footer-logo" alt="Ideal Logo" />
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        className="footer-container"
        style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Row className="pt-3 pt-md-5 pb-3 px-3 px-md-5">
          <Col
            lg={3}
            md={6}
            className="d-flex flex-column align-items-around justify-content-between"
          >
            <Image src={footerLogo} className="footer-logo" />
            <div className="mt-4 mt-md-0">
              <p className="mb-0">
                {settings?.footer_dynamic_text?.split("—")[0] ||
                  "Success isn’t just built on code — it’s built on"}
              </p>
              <h6 style={{ color: primaryColor }}>
                {settings?.footer_dynamic_text?.split("—")[1] ||
                  "purpose, people, and progress"}
              </h6>
            </div>

            <div className="d-flex gap-3 mt-4 mt-md-0">
              {settings?.facebook_url && (
                <a
                  href={settings.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  style={{
                    color: textLightColor,
                    backgroundColor: primaryColor,
                    borderRadius: "50%",
                    padding: "0.5rem",
                    height: "35px",
                    width: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaFacebookF />
                </a>
              )}
              {settings?.twitter_url && (
                <a
                  href={settings.twitter_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  style={{
                    color: textLightColor,
                    backgroundColor: primaryColor,
                    borderRadius: "50%",
                    padding: "0.5rem",
                    height: "35px",
                    width: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaXTwitter />
                </a>
              )}
              {settings?.instagram_url && (
                <a
                  href={settings.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  style={{
                    color: textLightColor,
                    backgroundColor: primaryColor,
                    borderRadius: "50%",
                    padding: "0.5rem",
                    height: "35px",
                    width: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaInstagram />
                </a>
              )}
              {settings?.linkedin_url && (
                <a
                  href={settings.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  style={{
                    color: textLightColor,
                    backgroundColor: primaryColor,
                    borderRadius: "50%",
                    padding: "0.5rem",
                    height: "35px",
                    width: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaLinkedinIn />
                </a>
              )}
            </div>
          </Col>
          <Col lg={3} md={6} className="pt-3 mt-4 mt-md-0">
            <h4 className="">IT Services</h4>
            <ul className="list-unstyled footer-list ">
              {services.map((service, index) => (
                <li key={index}>
                  <Link to={`/services/${service.service_slug}`}>
                    {service.service_title}
                  </Link>
                </li>
              ))}
              {services.length === 0 && (
                <li>
                  <Link to="/services">IT Services</Link>
                </li>
              )}
            </ul>
          </Col>
          <Col lg={3} md={6} className="pt-0 pt-md-3 mt-4 mt-md-5 mt-lg-0">
            <h4 className="">Contact Info</h4>
            <ul className="list-unstyled footer-list ">
              <li className="d-flex ">
                <Image
                  src={locationImg}
                  alt="Location"
                  className="me-2 footer-contact-icon"
                />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(settings?.address || "")}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {settings?.address ||
                    "#71, 3rd Main Road, Lakshmi Nagar Ext, Porur, Chennai 600116"}
                </a>
              </li>
              <li>
                <Image
                  src={phoneImg}
                  alt="Phone"
                  className="me-2 footer-contact-icon"
                />
                <a
                  href={`tel:${settings?.phone?.replace(/\s/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {settings?.phone || "+91 9994311042"}
                </a>
              </li>
              <li>
                <Image
                  src={emailImg}
                  alt="Email"
                  className="me-2 footer-contact-icon"
                />
                <a
                  href={`mailto:${settings?.email}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {settings?.email || "info@idealcorp.in"}
                </a>
              </li>
              <li>
                <Image
                  src={timeImg}
                  alt="Working Hours"
                  className="me-2 footer-contact-icon"
                />
                {settings?.working_hours || "Mon - Sat: 10:00 AM - 6:30 PM"}
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="pt-3 mt-md-5 mt-lg-0">
            <h4>Newsletter</h4>
            <ul className="list-unstyled footer-list">
              <li>
                {settings?.newsletter_description ||
                  "Stay in the loop — sign up for insights, updates, and cool stuff we build."}
              </li>
              <li className="mt-4 mt-lg-5">
                <Form
                  onSubmit={handleNewsletterSubmit}
                  className="input-group mt-2 mail-section"
                >
                  <Form.Control
                    type="email"
                    placeholder="your email"
                    className="rounded-pill rounded-end-0 ps-4 py-2"
                    style={{ fontSize: "14px" }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <Button
                    style={{
                      background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
                      border: "none",
                      marginLeft: "-20px",
                      zIndex: 9,
                    }}
                    type="submit"
                    className="rounded-pill "
                    disabled={status === "loading" || isContactSubmitting}
                  >
                    <GrSend />
                  </Button>
                </Form>
                {status === "success" && (
                  <p
                    className="text-success mt-2 mb-0"
                    style={{ fontSize: "12px" }}
                  >
                    Subscribed successfully!
                  </p>
                )}
                {status === "error" && (
                  <p
                    className="text-danger mt-2 mb-0"
                    style={{ fontSize: "12px" }}
                  >
                    Failed to subscribe. Please try again.
                  </p>
                )}
              </li>
            </ul>
          </Col>
        </Row>
        <Row
          className="py-2 mb-3"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.7)" }}
        >
          <Col xs={12} lg={6} className="m-auto">
            <p className="m-auto float-lg-end" style={{ fontStyle: "italic" }}>
              Copyright © {new Date().getFullYear()} All Rights Reserved | By{" "}
              {brandName}
            </p>
          </Col>
          <Col xs={12} lg={6} className="d-none d-lg-block">
            <ul className="d-flex flex-row footer-nav float-lg-end">
              {settings?.footer_bottom_menus ? (
                settings.footer_bottom_menus.map((menu, idx) => (
                  <li key={idx} className="me-5 list-unstyled">
                    <Link to={menu.url} className="text-dark">
                      {menu.label}
                    </Link>
                  </li>
                ))
              ) : (
                <>
                  <li className="me-5 list-unstyled">
                    <Link to="/" className="text-dark">
                      Home
                    </Link>
                  </li>
                  <li className="me-5">
                    <Link to="/aboutUs" className="text-dark">
                      About
                    </Link>
                  </li>
                  <li className="me-5">
                    <Link to="/blogs" className="text-dark">
                      Blogs
                    </Link>
                  </li>
                  <li className="me-5">
                    <Link to="/works" className="text-dark">
                      Works
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
